import axios from '../../utils/axios';

class AccountReceivableService {

	static async get(form) {
    return new Promise((resolve, reject) => {
      axios.post("admin/accounts-receivable", form).then(
        ({ data }) => {
          // http success
          resolve(data);
        },
        ({ response }) => {
          const { data } = response;
          // http failed
          reject(data);
        }
      );
    });
  }

	static async finish(form) {
    return new Promise((resolve, reject) => {
      axios.post("admin/accounts-receivable/finish", form).then(
        ({ data }) => {
          // http success
          resolve(data);
        },
        ({ response }) => {
          const { data } = response;
          // http failed
          reject(data);
        }
      );
    });
  }

	static async setPayment(form) {
    return new Promise((resolve, reject) => {
      axios.upload("admin/accounts-receivable/payment", form).then(
        ({ data }) => {
          // http success
          resolve(data);
        },
        ({ response }) => {
          const { data } = response;
          // http failed
          reject(data);
        }
      );
    });
  }

  static async setPaymentMultiple(form) {
    return new Promise((resolve, reject) => {
      axios.upload("admin/accounts-receivable/payment-multiple", form).then(
        ({ data }) => {
          // http success
          resolve(data);
        },
        ({ response }) => {
          const { data } = response;
          // http failed
          reject(data);
        }
      );
    });
  }
}

export default AccountReceivableService;